<template>
  <div class="BusinessCommentListModel">
    <div class="like-comment-wrapper">
      <header>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14.351 14.395"
          @click="CloseCommentModel"
        >
          <path
            class="a"
            d="M.2,1.168A.7.7,0,0,1,.2.2.7.7,0,0,1,1.17.2L7,6.035,12.837.2a.683.683,0,1,1,.961.971L7.97,7,13.8,12.836a.683.683,0,1,1-.961.971L7,7.969,1.17,13.807a.7.7,0,0,1-.971,0,.7.7,0,0,1,0-.971L6.028,7Z"
            transform="translate(0.198 0.196)"
          />
        </svg>
        <span>{{comments.length}} {{$t('Peoplehavecommented')}} </span>
      </header>
      <ul>
        <li v-for="(comment,index) in comments" :key="index" >
          <span v-if="comment.user_img">
            <img :src="comment.user_img" alt />
          </span>
          <span v-else>
            <img src="../../assets/images/user_images.png" />
          </span>
          <div class="name-comment">
            <span class="name">
              {{comment.user}}
              <span class="last-comment-time">
              <timeago :datetime="comment.time * 1000" :auto-update="60" />
                </span>
            </span>
            <span class="comment">{{comment.comment}}</span>
          </div>
        </li>
      </ul>
      <div class="comment_bottom">
        <div class="input_comment">
          <input type="text" name id :placeholder="$t('TypeAcomment')" v-model="remark" />
          <span class="send_comment" @click="sendComment()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.984"
              height="24.692"
              viewBox="0 0 24.984 24.692"
            >
              <g transform="matrix(0.809, -0.588, 0.588, 0.809, -9.417, -2.121)">
                <g transform="translate(0 16.02)">
                  <path
                    class="a"
                    d="M18.06,23.983.936,16.08a.662.662,0,0,0-.788.184.655.655,0,0,0-.016.809l5.631,7.508L.132,32.089a.658.658,0,0,0,.8.993l17.124-7.9a.659.659,0,0,0,0-1.2Z"
                    transform="translate(0 -16.02)"
                  />
                </g>
              </g>
            </svg>
          </span>
        </div>
      </div>
    </div>
      <div class="loader" v-if="loading">
      <img src="../../assets/images/gif-loader.gif" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { toaster } from "../../utils/helper";
export default {
  name: "BusinessCommentListModal",
  components: {},
  props: {
    feedIndex:{
      required: false,
      type: Number
    }
  },
  watch:{
    feedIndex:function(newvalue, oldValue){
      this.comments=this.feeds.filter(feed => feed.id == newvalue)[0].comments;
    }
  },
  data() {
    return {
      remark: "",
      comments:[],
      loading: false
    };
  },
  computed: {
    ...mapState(["feeds"])
  },
  methods: {
    ...mapMutations(["AddComments"]),
    CloseCommentModel() {
      document
        .querySelector("body")
        .classList.remove("BusinessCommentList_Body");
    },
    sendComment() {
      if (this.remark !="") {
        const obj = {
          message: this.remark,
          feed_id: this.feedIndex
        };
        this.$store.dispatch({ type: "postCmnt", payload: obj }).then(
          data => {
            this.remark='';
            if (data && data.data && data.data[0]){
              this.AddComments({
                id: this.feedIndex,
                commentdetails: data.data[0]
              });
            }
          }).catch(err => {
          toaster(
            this,this.$t("wentWrong"),
            "top-center",
            2000
          );
        });
      } else {
         toaster(
            this,this.$t("Pleaseentercomment"),
            "top-center",
            2000
          );
      }
    }
  }
};
</script>
<style></style>
